import en from './en';
import reviews from './review';
import redirectModals from './redirect-modals';

const Lang = {
  ...en,
  ...reviews,
  redirectModals,
  formValidation: {
    required: (field) => `${field} is required`,
    notZero: (field) => `${field} is required`,
    minLength: (field, number) => `${field} needs to be at least ${number.min} characters long`,
    maxLength: (field, number) => `${field} needs to be at max ${number.max} characters long`,
    minValue: (field) => `${field} cannot be in the past`,
    email: () => 'Your email does not appear to be valid',
    passwordMatch: () => 'Passwords do not match',
    sameAs: () => 'Password fields do not match',
    decimal: (field) => `${field} must be a number`,
    numeric: (field) => `${field} can only contain numbers 0-9`,
  },
  siteName: 'RateMyApprenticeship',
};

// TODO: sidePanel object can be removed

export default Lang;
